import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageService } from "../../../../app/shared/service/storage/storage.service";
import { BehaviorSubject, Observable, of } from "rxjs";
import { AdminEndPoint ,DndPortalPoint} from '../../lib/api-constant';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserControlService {

  // private userConfig: any = null;
  private userFeaturesPromise = new BehaviorSubject<any>([{ id: 1, name: "Event Tracking" }]);
  public $userFeatures = this.userFeaturesPromise.asObservable();

  private userCompanyPromise = new BehaviorSubject<any>(null);
  public $userCompany = this.userCompanyPromise.asObservable();

  private isUserBdpEmployeePromise = new BehaviorSubject<Object>({});
  public $isUserBdpEmployee = this.isUserBdpEmployeePromise.asObservable();

  private getUserInformations = new BehaviorSubject<any>([]);
  public $getUserInformation = this.getUserInformations.asObservable();

  private userAttributesPromise = new BehaviorSubject<any>({});
  public $userAttributes = this.userAttributesPromise.asObservable();

  private userAppsPromise = new BehaviorSubject<any>(null);
  public $userAppsList = this.userAppsPromise.asObservable();




  private existingUsertableHeaders: any[] = [
    { field: 'firstName', header: 'First Name' },
    { field: 'lastName', header: 'Last Name' },
    { field: 'company', header: 'Company Name' },
    { field: 'email', header: 'Email Address' },
    { field: 'groupName', header: 'Assigned Companies' },
    { field: 'actions', header: 'Actions' },
  ];
  private pendingUsertableHeaders: any[] = [
    { field: 'firstName', header: 'First Name' },
    { field: 'lastName', header: 'Last Name' },
    { field: 'company', header: 'Company Name' },
    { field: 'email', header: 'Email Address' },
    { field: 'actions', header: 'Actions' },
  ];
  selectedUsers: any[];
  companies: any[]
  assignments: any[];
  getAllApps() {
    const token = this.storageService.getItem('token');
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
    });
    return this.http.get(environment.ump_endpoint_url+"/"+DndPortalPoint.UserApi.GET_ALL_APPS, { headers });
}
  companyDetails: any;
  constructor(
    protected http: HttpClient,
    protected storageService: StorageService) {
  }
  
  // getUserSettings(): Observable<any> {
  //   return of(this.permissions);
  // }

  updateUserApps(value:any) {
    this.userAppsPromise.next(value);
  }

  updateUserSettings(details: any) {
    this.userFeaturesPromise.next(details);
  }

  getCompanyDetails(): Observable<any> {
    return this.http.get(AdminEndPoint.CommanyManagement.GET_COMPANY);  // Your Company API endpoint
  }

  setCompanyDetails(details: any): void {
    this.companyDetails = details;
  }

  getStoredCompanyDetails(): any {
    return this.companyDetails;
  }

  getUserFeaturesWithPrivileges(): Observable<any> {
    return this.http.get(AdminEndPoint.UserManagement.USERS_CONFIG); 
  }

}
